import { SpecificWaybillModalComponent } from "./../specific-waybill-modal/specific-waybill-modal.component";
import { WaybillService } from "./../../services/waybill.service";
import { NewWaybillModalComponent } from "./../new-waybill/newWaybillModal.component";
import { Component, OnInit } from "@angular/core";
import { LocalDataSource } from "ng2-smart-table";
import * as moment from "moment";
import { NotifierService } from "../../shared/notifier/notifier.service";
import { InternalService } from "../../services/internal.service";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material";
import { AlertComponent } from "../../../shared";
import * as fileSaver from "file-saver";
import { ReportesService } from "../../services/reportes.service";
import "rxjs/add/operator/filter";
import { WorkOrderService } from "../../services/work-order.service";
import { isEmpty } from "rxjs/operator/isEmpty";
import { ListofvaluesService } from "../../services/listofvalues.service";
import { resolve } from "path";
import { map, startWith } from "rxjs/operators";
import { Observable } from "rxjs";
import { NgForm, FormControl } from "@angular/forms";
import { BillingService } from "../../services/billing.service";

@Component({
  selector: "app-waybill-list",
  templateUrl: "waybill-list.component.html",
  styleUrls: ["waybill-list.component.scss"],
  providers: [
    WorkOrderService,
    ListofvaluesService,
    ReportesService,
    BillingService,
    WaybillService,
  ],
})
export class WaybillListComponent implements OnInit {
  tableSettingsWaybillHeader: any = undefined;
  dataSourceWaybillHeader: any = undefined;
  tableDataWaybillHeader: any = {};
  ldvStates: any = {};
  params: any = {};
  wo_id: number;
  currentId: number;
  currentCode: string;
  work_orders: Array<any> = [];
  select_wo: boolean = false;
  todos_activo = true;
  vigentes_activo = false;
  vencidos_activo = false;
  archivados_activo = false;
  showArchived = false;
  woFilterCode = "";
  perPage = 10;
  settings = {
    pager: { display: true, perPage: this.perPage },
    noDataMessage: "No hay datos que mostrar.",
    columns: undefined,
    actions: {
      add: false,
      delete: false,
      position: "right",
      edit: false,
      columnTitle: "Acciones",
      custom: [
        { name: "editar", title: `<div class="editCustomButton">Editar</div>` },
        {
          name: "eliminar",
          title: `<div class="editCustomButton">Eliminar</div>`,
        },
        //{ name: 'archivar', title: `<div class="editCustomButton">Archivar</div>` }
      ],
    },
  };

  myControlOrders = new FormControl();
  options: string[] = [];
  filteredOrders: Observable<string[]>;

  constructor(
    private reporteService: ReportesService,
    private workOrderService: WorkOrderService,
    private listofvalueService: ListofvaluesService,
    private notifierService: NotifierService,
    private routes: Router,
    private activedRoutes: ActivatedRoute,
    private billingService: BillingService,
    private dialog: MatDialog,
    private waybillService: WaybillService,
    private internalService: InternalService
  ) {
    this.tableDataWaybillHeader = {
      columns: {
        guideName: { title: "Numero Guia" },
        dispatch_point: { title: "Punto de salida" },
        arrival_point: { title: "Punto de arrivo" },
        start_date: { title: "F. Despacho" },
        isEmited: { title: "Electronico" },
      },
      data: {},
    };
    this.params = this.activedRoutes.params;
    this.wo_id = this.params.value.id;

    this.workOrderService
      .getAllWorkOrders(0)
      .subscribe((result: Array<any>) => {
        this.work_orders = result;
        this.work_orders.forEach((element) => {
          this.options.push(element.external_code);
        });

        this.filteredOrders = this.myControlOrders.valueChanges.pipe(
          startWith(""),
          map((value) => this._filter(value, this.options))
        );
      });
  }

  private _filter(value: string, options): string[] {
    const filterValue = value.toLowerCase();

    return options.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  ngOnInit() {
    this.listofvalueService
      .getLdvByCode("TBWA-STATE-BUDGET")
      .subscribe((result) => {
        this.ldvStates = result;
        //console.log(result);
        this.cargarTodos();
      });
  }

  newWaybill() {
    if (this.dataSourceWaybillHeader.data.length > 0) {
      let number =
        Number(
          this.dataSourceWaybillHeader.data[
            this.dataSourceWaybillHeader.data.length - 1
          ].number_guide
        ) + 1;
      this.internalService.internalNotify({
        numGuide: number,
        first: false,
        show: false,
      });
    } else {
      this.internalService.internalNotify({
        numGuide: 1,
        first: true,
        show: false,
      });
    }
    const dialogRef = this.dialog.open(NewWaybillModalComponent);
  }

  cargarTodos() {
    this.todos_activo = true;
    this.vigentes_activo = false;
    this.vencidos_activo = false;
    this.showArchived = false;

    var todos = [];

    this.waybillService.getWaybills().subscribe((resultWaybill: any) => {
      this.dataSourceWaybillHeader = resultWaybill;
      this.dataSourceWaybillHeader.forEach((item) => {
        item.start_date = item.start_dispatch_date.slice(0, 10);
        item.isEmited = item.is_generated ? "si" : "no";
        item.guideName = item.guide_serie + "-" + item.number_guide;
      });
      //console.log('data',this.dataSourceWaybillHeader)

      this.settings.actions.custom = [];
      this.settings.actions.custom = [
        { name: "ver", title: `<div class="editCustomButton">Ver Guia</div>` },
        //{ name: 'archivar', title: `<div class="editCustomButton">Archivar</div>` }
      ];
      this.getTableData(this.dataSourceWaybillHeader);
    });
  }

  cargarArchivados() {}

  copyObject(obj): object {
    return JSON.parse(JSON.stringify(obj));
  }

  async getTableData(result) {
    /*this.notifierService.systemNotify({
      title: 'Espere',
      message: 'Cargando presupuestos',
      type: 'info'
    });*/
    const cloneRows: Array<any> = [...result];
    this.dataSourceWaybillHeader = new LocalDataSource(cloneRows);
    this.tableSettingsWaybillHeader = this.copyObject(this.settings);

    if (this.tableDataWaybillHeader.columns !== undefined) {
      this.tableSettingsWaybillHeader.columns = this.copyObject(
        this.tableDataWaybillHeader.columns
      );

      Object.keys(this.tableSettingsWaybillHeader.columns).forEach((key) => {
        this.tableSettingsWaybillHeader.columns[key].filter = true;
      });
    }
  }

  customAction(event) {
    switch (event.action) {
      case "ver":
        this.waybillService.getOneWaybill(event.data.id).subscribe((res) => {
          this.internalService.internalNotify({ message: res, show: false });
          const dialogRef = this.dialog.open(SpecificWaybillModalComponent, {
            height: "90vh",
            width: "70vh",
          });
        });
        break;
      case "archivar":
        const archivarDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: "exclamation-circle",
            iconColor: "failure",
            title: "Aviso",
            text: "¿Está seguro que desea archivar el Presupuesto?",
            options: true,
          },
        });
        /*archivarDialog.afterClosed().subscribe((result) => {
          if (result) {
            let budgetupd = event.data;
            budgetupd.state = 9;
            this.budgetService.updateBudget(budgetupd).subscribe((result) => {
              this.notifierService.systemNotify({
                title: 'Éxito',
                message: 'Se ha archivado el presupuesto',
                type: 'success'
              });
              if (this.todos_activo) this.cargarTodos();
              else if (this.vigentes_activo) this.cargarVigentes();
              else if (this.vencidos_activo) this.cargarVencidos();
            }), err => {
              console.log('error', err);
              this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message: 'Por favor póngase en contacto con el administrador ' + err,
                type: 'error'
              });
            };
          }
        }, (error) => {
          console.log('error', error);
        });*/
        break;
      case "desarchivar":
        const desarchivarDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: "exclamation-circle",
            iconColor: "failure",
            title: "Aviso",
            text: "¿Está seguro que desea desarchivar el Presupuesto?",
            options: true,
          },
        });
        /*desarchivarDialog.afterClosed().subscribe((result) => {
          if (result) {
            let budgetupd = event.data;
            budgetupd.state = 1;
            this.budgetService.updateBudget(budgetupd).subscribe((result) => {
              this.notifierService.systemNotify({
                title: 'Éxito',
                message: 'Se ha desarchivado el presupuesto',
                type: 'success'
              });
              this.cargarArchivados();
            }), err => {
              console.log('error', err);
              this.notifierService.systemNotify({
                title: 'Ha ocurrido un error',
                message: 'Por favor póngase en contacto con el administrador ' + err,
                type: 'error'
              });
            };
          }
        }, (error) => {
          console.log('error', error);
        });*/
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/system/waybill/waybill-list/waybill-list.component.ts